import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './charter-block1440px.module.scss';
import Button1 from '../JetCard/Components/Button1/Button1';
import FooterButton from '../Footer/components/FooterButton/FooterButton';

export type CharterBlock1440pxType = {
  className?: string;
};

const CharterBlock: NextPage<CharterBlock1440pxType> = ({ className = '' }) => {
  return (
    <div className="container">
      <div className={[styles.charterblock1440px, className].join(' ')}>
        <div className={styles.featuresblock}>
          <Image
            className={styles.imageIcon}
            loading="lazy"
            width={574}
            height={290}
            sizes="100vw"
            alt=""
            src="/img/charterBlock/charter-block-image.webp"
          />
          <div className={styles.leftcol}>
            <h2 className={styles.title}>
              <p
                className={styles.lookingForAnother}
              >{`Looking for another type `}</p>
              <p className={styles.lookingForAnother}>of jet to charter?</p>
            </h2>
            <div className={styles.descriptor}>
              <span className={styles.callHeraFlightToday}>
                Call Hera Flight today and we can make sure you are on your
                preferred aircraft.
              </span>
            </div>
            <div className={styles.buttons}>
              <FooterButton
                className={styles.footerButton}
                color="accent"
                highContrast={false}
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text="Request a call"
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                href="/contact"
              />
              <Button1
                className={styles.button1}
                text="Call to 1-833-FLY-HERA"
                href="tel:18335394372"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharterBlock;
